var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerTertiary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic/24/marker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "geo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 16",
    d: "M12.6846 6.46219C12.6846 6.99792 12.4209 7.74345 11.9328 8.62395C11.4562 9.48367 10.8127 10.3904 10.1568 11.2253C9.50291 12.0577 8.84738 12.8052 8.35448 13.3454C8.22414 13.4883 8.10539 13.6164 8.0013 13.7275C7.89721 13.6164 7.77846 13.4883 7.64812 13.3454C7.15522 12.8052 6.49969 12.0577 5.84577 11.2253C5.18992 10.3904 4.54636 9.48367 4.0698 8.62395C3.58171 7.74345 3.31797 6.99792 3.31797 6.46219C3.31797 4.01274 5.39051 1.98398 8.0013 1.98398C10.6121 1.98398 12.6846 4.01274 12.6846 6.46219Z",
    stroke: "#6B6B6D",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 17",
    d: "M9.48385 6.46241C9.48385 7.21253 8.84401 7.8637 8.00052 7.8637C7.15704 7.8637 6.51719 7.21253 6.51719 6.46241C6.51719 5.7123 7.15704 5.06113 8.00052 5.06113C8.84401 5.06113 9.48385 5.7123 9.48385 6.46241Z",
    stroke: "#6B6B6D",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerTertiary);
export default __webpack_public_path__ + "static/media/marker_tertiary.2f1a02211740573e3659aad2fbd9041b.svg";
export { ForwardRef as ReactComponent };